<template>
  <div>
    <div class="card height-auto v-application--is-ltr text-left">
      <div class="card-body">
        <v-col md="4" sm="12">
          <h3 class="custom-header main-color" style="text-align: left">
            {{ $t("Certificates") }}
          </h3>
        </v-col>
        <div class="card-body"></div>
        <v-row class="mb-7">
          <v-col md="5" sm="12">
            <!-- Acadimice Year -->
            <v-row>
              <v-col cols="4" sm="4" class="academic">
                <label for="academicPeriods" class="label">{{
                  $t("Academic Year")
                }}</label>
              </v-col>
              <v-col cols="8" sm="8">
                <v-autocomplete
                  id="academicPeriods"
                  v-model="selectedAcademicPeriodId"
                  :items="academicPeriods"
                  item-text="en.name"
                  item-value="id"
                  @change="getGrades()"
                  solo
                ></v-autocomplete>
              </v-col>
            </v-row>
            <!-- Grades -->
            <v-row>
              <v-col md="4" sm="4" class="">
                <p class="mt-2">Grade</p>
              </v-col>
              <v-col md="8" sm="8">
                <v-autocomplete
                  :label="$t('Grade')"
                  :items="grades"
                  item-text="name"
                  item-value="id"
                  v-model="selectedGrade"
                  @change="getClasses()"
                  solo
                ></v-autocomplete>
              </v-col>
            </v-row>

            <!-- Class -->
            <v-row>
              <v-col md="4" sm="4" class="">
                <p class="mt-2">Class</p>
              </v-col>
              <v-col md="8" sm="8">
                <v-autocomplete
                  :label="$t('Class')"
                  :items="classes"
                  item-text="name"
                  item-value="id"
                  v-model="selectedClass"
                  @change="getAllData()"
                  solo
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
          <v-col md="2" cols="12"></v-col>
          <v-col md="5" cols="12"></v-col>
        </v-row>
        <!-- :loading="loading" -->
        <!-- v-model="selected" -->
        <v-row>
          <v-col cols="12" md="6">
            <v-data-table
              :options.sync="options"
              loading-text="Loading... Please wait"
              :headers="headers"
              :items="items"
              item-key="student_id"
              :show-select="false"
              class="elevation-1 level1 templates"
              text="left"
              hide-default-footer
            >
              <template v-slot:item.name="{ item }">
                <router-link
                  :to="
                    '/uploaded-certificates/files/' +
                    item.code +
                    '/' +
                    selectedAcademicPeriodId
                  "
                  >{{ item.name }}</router-link
                >
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <!-- ======================================== Pagination ======================================  -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
// import ACL from "../../acl";
export default {
  name: "uploadedCertificates",

  data() {
    return {
      options: {
        itemsPerPage: -1,
      },

      activeAcademicPeriod: "",
      selectedAcademicPeriodId: "",
      academicPeriods: [],
      selectedGrade: "",
      loading: true,

      uploadingError: false,

      //   selected: [],
      headers: [
        // {
        //   text: this.$i18n.t("Code"),
        //   value: "code",
        //   sortable: true,
        // },
        {
          text: this.$i18n.t("Student Name"),
          value: "name",
          sortable: false,
        },
        // {
        //   text: this.$i18n.t("Certificate"),
        //   value: "certificate",
        //   sortable: false,
        // },

        // { text: this.$i18n.t("Actions"), value: "actions", sortable: false },
      ],
      // fileObject: "",
      title: this.$i18n.t("Certificates"),

      items: [],

      // selectGrade: "",

      selectedClass: "",
      //   quarters: [],
      grades: [],
      classes: [],
    };
  },
  watch: {
    selectedAcademicPeriodId: {
      handler() {
        if (this.selectedAcademicPeriodId != "") {
          this.getGrades();
        }
      },
      deep: true,
    },
    // selectedClass: {
    //   handler() {
    //     if (this.selectedClass != "") {
    //       this.getAllData();
    //     }
    //   },
    //   deep: true,
    // },
  },
  methods: {
    getAcademicPeriods() {
      axios
        .get(this.getApiUrl + "/school/showAcademicPeriod?list=yes", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            //the token is a variable which holds the token
          },
        })
        .then((response) => {
          this.academicPeriods = response.data.data;
          this.selectedAcademicPeriodId = this.academicPeriods.find(
            (object) => object.is_active == 1
          ).id;

          this.activeAcademicPeriod = this.selectedAcademicPeriodId;
          if (this.$router.currentRoute.query.year) {
            this.selectedAcademicPeriodId = Number(
              this.$router.currentRoute.query.year
            );
          }
        });
    },
    getGrades() {
      if (this.selectedAcademicPeriodId != "") {
        axios
          .get(
            this.getApiUrl +
              "/performance/getGradeOfYear/" +
              this.selectedAcademicPeriodId,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
              },
            }
          )
          .then((response) => {
            this.grades = response.data.data;
            if (this.$router.currentRoute.query.grade) {
              this.selectedGrade = Number(
                this.$router.currentRoute.query.grade
              );

              this.getClasses();
            }
            this.classes = [];
            this.items = [];
          });
      }
    },
    getClasses() {
      if (this.selectedGrade != "") {
        axios
          .get(
            this.getApiUrl +
              "/performance/getClassesOfGrade/" +
              this.selectedGrade,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
              },
            }
          )
          .then((response) => {
            this.classes = response.data.data.classes;
            if (this.$router.currentRoute.query.class) {
              this.selectedClass = Number(
                this.$router.currentRoute.query.class
              );
              this.getAllData();
            }
            this.items = [];
          });
      }
    },
    getAllData() {
      if (this.selectedClass != "" && this.selectedGrade != "") {
        axios
          .get(
            this.getApiUrl +
              "/performance/students/" +
              this.selectedClass +
              "/" +
              this.selectedGrade,
            {
              headers: {
                Authorization: "Bearer " + localStorage.token,
              },
            }
          )
          .then((response) => {
            this.items = [];
            this.items = response.data.data;
            this.loading = false;
          });
      }
    },
  },
  mounted() {
    this.getAcademicPeriods();

    // this.getQuarters();
    // this.getGrades();
    // this.getClasses();
  },
};
</script>
<style lang="scss" scoped>
@import "../../styles/_variables.scss";
@import "../../styles/_modals.scss";

#wrapper {
  transition: all 0.4s ease 0s;
}

.main-color {
  color: $main-color;
}
.headerTable-div {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #fff;

  .custom-header {
    margin-bottom: 0;
  }
}

.center {
  margin-left: 30px !important;
}

.select {
  margin-top: 20px !important;
}
</style>
